import { VIEWPORT_DEFAULT_MOBILE } from 'modules/viewport/constants'

function createViewportUtil () {
  if (SERVER) {
    return {
      ...VIEWPORT_DEFAULT_MOBILE
    }
  }
  return {
    width: document.documentElement.clientWidth || window.innerWidth,
    height: document.documentElement.clientHeight || window.innerHeight
  }
}

export default createViewportUtil
